import React from 'react';

import './App.css';

import MATTLogo from './assets/logo.svg';
import MATTLineup from './assets/matt_gray_standard.jpg';


function App() 
{
  return (
    <div className={ `d-lg-flex half` } >
      <div className="bg order-1 order-md-2" style={ { backgroundImage: `url(${MATTLineup})`, backgroundColor: '#383838' } }></div>
      <div className="contents order-2 order-md-1">

        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-md-7">
              <h1><img src={MATTLogo} alt="MATT" className='logo-matt'/>Documentation</h1>
              <h2 className="mb-4 subtitle-matt">Extensive documentation and support resources for interacting with any device</h2>
              
              <div className="buttons">
                <a type="button" href="/api/v2/sso/login" className="btn btn-block btn-success btn-primary btn-login">
                  Log In
                </a>

                <a type="button" href="/api/v2/sso/register" className="ml-4 btn btn-block btn-success btn-primary btn-login btn-register">
                  Request Access
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
